export const COMPONENT_NAME = 'SubNavigation';
export const COMPONENT_SUBNAVIGATION_LIST_WRAP = 'SubNavigation-List-Wrap';
export const COMPONENT_SUBNAVIGATION_LIST = 'SubNavigation-List';
export const COMPONENT_CONTAINER = 'SubNavigation-Container';
export const COMPONENT_SLIDER = 'SubNavigation-Slider';
export const COMPONENT_GRID_BLOCK = 'SubNavigation-GridBlock';
export const COMPONENT_GRID_CONTAINER = 'SubNavigation-GridContainer';
export const COMPONENT_NAVIGATION = 'SubNavigation-GridItem-NavList';
